<template>
  <div
    style="position: relative; width: 100%; height: auto; background: #152331;"
  >
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <template v-if="latestNews.length > 0">
          <transition-group name="fade" appear>
            <template v-for="(list, index) in latestNews" :key="index">
              <component
                :is="
                  list.length !== pageSize
                    ? 'universalList'
                    : index - 1 === -1 && show.topBar
                    ? 'defaultBar'
                    : `bar${(index - (show.topBar ? 1 : 0))
                        .toString()
                        .substr(-1)}`
                "
                :list="list"
                transition-mode="out-in"
              />
            </template>
          </transition-group>
        </template>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  reactive,
  watch,
  onMounted,
  onBeforeUnmount
} from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/politics/MainBar.vue";
import FirstBar from "@/components/politics/FirstBar";
import SecondBar from "@/components/politics/SecondBar";
import ThirdBar from "@/components/politics/ThirdBar";
import FourthBar from "@/components/politics/FourthBar";
// import FivthBar from "@/components/world/FivthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";

export default {
  components: {
    defaultBar: MainBar,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,
    bar4: MainBar,

    bar5: FirstBar,
    bar6: SecondBar,
    bar7: ThirdBar,
    bar8: FourthBar,
    bar9: MainBar
  },
  setup() {
    const store = useStore();
    const inner = ref(null);
    const show = reactive({
      topBar: true,
      spinner: true
    });

    const { i18n } = useLanguage();


    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 9;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'politics',
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd
    });

    const checkWidth = () => {
      show.topBar = window.innerWidth >= 993;
    };

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    refreshData();

    watch(
      () => i18n.global.locale.value,
      () => refreshData()
    );

    onMounted(() => {
      window.addEventListener("resize", resizeThrottler, false);
      // window.addEventListener("deviceorientation", resizeThrottler, true);
      resizeThrottler();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
      // window.removeEventListener("deviceorientation", resizeThrottler);
    });

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>

<style lang="scss" scoped>
.main-news-wrapper {
  --width-media: 90%;
  --category-color: #939393;
  --black-text: #121212;
  --dark-bg: #152331;
  --dark-blog-bg: #131d27;
  --strip: #192938;

  margin: 0 auto;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 1000px;
    background: linear-gradient(360deg, #152331 0%, #091420 100%);
  }
  .inner {
    position: relative;
    width: 90%;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.125rem;
    :deep() .card {
      &__title {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: calc(max(1.19em, 1vw));
        line-height: 1.2;
        color: #fff;
      }
      .data-news {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: calc(max(0.88em, 0.7vw));
        line-height: 1.2;
        color: rgba(255, 255, 255, 0.8);
        margin-top: 7px;
      }
      &__category-img {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: calc(max(1em, 0.9vw));
        line-height: 1.2;
        color: rgba(255, 255, 255, 0.7);
      }
      &__category-descr {
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: calc(max(1em, 0.9vw));
        line-height: 1.2;
        color: rgba(255, 255, 255, 0.7);
      }
      &__brief {
        // display: none;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: calc(max(1em, 0.9vw));
        line-height: 1.5;
        color: #a2a2a2;
      }
      .data-news-brief {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: calc(max(0.88em, 0.7vw));
        // font-size: 14px;
        line-height: 1.5;
        text-align: right;
        // color: rgba(255, 255, 255, 0.8);
        margin-top: 8px;
      }
      &__img {
        overflow: hidden;
        :deep() .main-image img {
          border-radius: 0px;
          overflow: visible;
        }
      }
      @media screen and (max-width: 992px) {
        &__title {
          font-size: 16px;
          line-height: 22px;
        }
        .data-news {
          font-family: Open Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 18px;
        }
        &__category-img {
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
          text-transform: uppercase;
        }
        &__category-descr {
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
          color: rgba(255, 255, 255, 0.7);
          text-transform: uppercase;
          margin-bottom: 0.25rem;
        }
        &__brief {
          font-family: Roboto;
          font-style: normal;
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;
        }
        .data-news-brief {
          font-family: Open Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          margin-top: 8px;
        }
      }
      @media screen and (max-width: 767px) {
        &__title {
          font-style: normal;
          font-size: 12px;
          line-height: 15px;
        }
        .data-news {
          font-family: Open Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 10px;
          line-height: 14px;
        }
        &__category-img {
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 10px;
          line-height: 14px;
        }
        &__category-descr {
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 10px;
          line-height: 14px;
          text-transform: uppercase;
          margin-bottom: 0.25rem;
        }
        &__brief {
          font-family: Roboto;
          font-style: normal;
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;
        }
        .data-news-brief {
          font-family: Open Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 10px;
          line-height: 14px;
        }
      }
    }
    @media screen and (max-width: 1200px) {
      font-size: 12px;
    }
    @media screen and (max-width: 992px) {
      font-size: 14px;
      width: 100%;
    }
  }
}

@media screen and (max-width: 1366px) {
  .main-news-wrapper {
    .inner {
      zoom: 0.7;
    }
  }
}
@media screen and (max-width: 992px) {
  .main-news-wrapper {
    .inner {
      zoom: 1;
    }
  }
}
</style>
